import DOMManipulations from './DOMManipulatiuons';

export default DOMManipulations;
